export enum BlockExplorerEvents {
  SwitchTabPools = 'switch_tab_pools',
}

export type BlockExplorerTrackEvents = {
  [BlockExplorerEvents.SwitchTabPools]: {
    path: string;
    pool: string;
    tab: string;
  };
};
